import { base } from './base'

export const box = {
  ...base,
  backgroundColor: 'white',
  position: 'static',
  overflow: 'hidden',
  padding: '10px 30px',
  width: '420px',
  height: 'auto',
  maxWidth: '100%',
  maxHeight: '100%',
  margin: '50px auto',
  marginTop: '10vh',
  boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
  borderRadius: '4px',
}
